import { BooleanInput } from '@angular/cdk/coercion';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { User } from 'app/core/user/user.types';
import { AuthService, PermissionCheckService } from 'app/shared/services/core';
import { UsuarioService } from 'app/shared/services/edduca-imob/usuario/usuario.service';
import { WhiteLabelStateService } from 'app/shared/services/edduca-imob';
import { HasProfileDirective } from 'app/shared/directives/has-profile.directive';
import { PerfilEnum } from 'app/shared/models/core/security/perfil.enum';
import { firstValueFrom, Subject } from 'rxjs';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    imports: [
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatDividerModule,
        HasProfileDirective,
    ],
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */
    @Input() nomeUsuario: string = '';
    @Input() showAvatar: boolean = true;
    user: User;
    fotoPerfil: string | null = null;

    // Expondo o enum para uso no template
    readonly PerfilEnum = PerfilEnum;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UsuarioService,
        private _authService: AuthService,
        private _wlState: WhiteLabelStateService,
        public permissionService: PermissionCheckService,
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit(): Promise<void> {
        // Fetch nomeUsuario asynchronously
        const usuario = this._authService.getUserInToken();
        if (usuario) {
            await firstValueFrom(this._userService.getUsuarioById(usuario.userId))
                .then(u => {
                    this.nomeUsuario = u.nome;
                    
                    // URL da foto já vem do backend
                    this.fotoPerfil = u.urlFotoPerfil || null;
                    
                    this._changeDetectorRef.markForCheck();
                });
        }

        // Subscribe to user changes
        // this._userService.user$
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe((user: User) => {
        //         this.user = user;

        //         // Mark for check
        //         this._changeDetectorRef.markForCheck();
        //     });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    /**
     * Sign out
     */
    imobRedirect(): void {
        this._router.navigate(['/imobiliaria/imobiliaria-pesquisa']);
    }

    cupomRedirect(): void {
        this._router.navigate(['/cupom/cupom']);
    }

    userRedirect(): void {
        this._router.navigate(['/usuario/usuario-pesquisa']);
    }

    myCommissions() {
        this._router.navigate(['/comissao']);
    }

    trilhaRedirect(): void {
        this._router.navigate(['/trilha/trilha-pesquisa']);
    }

    moduloRedirect(): void {
        this._router.navigate(['/modulo/modulo-pesquisa']);
    }

    aulaRedirect(): void {
        this._router.navigate(['/aula/aula-pesquisa']);
    }

    bannerRedirect(): void {
        this._router.navigate(['/banner/banner-pesquisa']);
    }

    parametrosRedirect(): void {
        this._router.navigate(['/parametros']);
    }

    meuPerfil(): void {
        this._router.navigate(['/meu-perfil']);
    }

    minhaImobiliaria(): void {
        this._router.navigate(['/minha-imobiliaria']);
    }

    solicitacoesEnterpriseRedirect(): void {
        this._router.navigate(['/solicitacoes-enterprise']);
    }

    parceriaComercialRedirect(): void {
        this._router.navigate(['/parceria-comercial/parceria-comercial-pesquisa']);
    }

    signOut(): void {
        // Limpa o WL aplicado e re-detecta pelo subdomínio (caso esteja em subdomínio com WL)
        this._wlState.clear();
        const slug = this._wlState.extrairSlugDoHostname();
        if (slug) this._wlState.carregarPorSlug(slug);

        this._authService.clearToken();
    }
}
